import React from 'react'
import styles from './IconNetwork.module.scss'

export default function IconNetwork() {
    return <div className={styles.root} />
}
